import { trace } from 'rytm-helpers'
import RytmWebflow from 'rytm-webflow'
import { store } from './../store'
import { mediaLoadStart, mediaLoadComplete } from './../actions/actions_gui'
import { pauseSoundMain, resumeSoundMain, volumeUpSoundAmbient, volumeDownSoundAmbient } from './../actions/actions_audio'
import { videoPlaybackStart, videoPlaybackStop } from './../actions/actions_video'

const SECONDS_TO_HIDE_INTERFACE = 3
const CLASS_MAKE_WAY_FOR_VIDEO = "media-hide-interface"
const CLASS_VIDEO_LOADING = "loading"
const CLASS_VIDEO_LOADED = "loaded"
const CLASS_VIDEO_PLAYING = "playing"
const CLASS_VIDEO_PLAYBACK_PAUSED = "video-paused"
const CLASS_VIDEO_LOOPED = "video-looped"
let currentView = null
let videoPaused = false
let videoCC = 0
let loopCC = 0
let videoProgressBarInterval = null

export const initVideoState = () => {
  store.subscribe(onStoreChange)
  document.addEventListener("click", onDocClick)
  document.addEventListener("mousemove", onDocAction)
  document.addEventListener("keydown", onDocAction)
  // init interval for html class on video playback (hide controlls NETFLIX like)
  setInterval(onVideoInterval, 1000)
}
/**
 * update videos state
 */
const updateVideosState = () => {
  const list = [...document.querySelectorAll(".tsaw-video-view")]
  list.forEach(checkVideo)
}
const checkVideo = (el, index) => {
  if (!el.classList.contains(CLASS_VIDEO_LOADING) 
      && !el.classList.contains(CLASS_VIDEO_LOADED)) {
    if (el.dataset.src) {
      el.classList.add(CLASS_VIDEO_LOADING)
      el.addEventListener("loadedmetadata", onTsawVideoLoadedMeta)
      el.addEventListener("loadeddata", onTsawVideoLoadedData)
      el.addEventListener("canplay", onTsawVideoCanPlay)
      el.addEventListener("canplaythrough", onTsawVideoCanPlayThrough)
      el.addEventListener("playing", onTsawVideoPlaying)
      el.addEventListener("pause", onTsawVideoPause)
      el.addEventListener("ended", onTsawVideoEnded)
      mediaLoadStart(el.dataset.id)
      const source = document.createElement('source')
      source.setAttribute("src", el.dataset.src)
      source.setAttribute("type", "video/mp4")
      el.appendChild(source)
    }
  }
}
const pauseVideos = () => {
  const list = [...document.querySelectorAll(".tsaw-video-view")]
  list.forEach(pauseVideo)
}
const resumeVideos = () => {
  const list = [...document.querySelectorAll(".tsaw-video-view")]
  list.forEach(resumeVideo)
}
const pauseVideo = (el, index) => {
  // trace("pause video", el)
  el.pause()
}
const resumeVideo = (el, index) => {
  // trace("resume video", el)
  el.play()
}

/**
 * ##################################
 * ### DOM element event handlers ###
 */
const onDocClick = (e) => {
  // vide play button click
  if (e.target?.dataset?.tsawVideoPlay) {
    e.preventDefault();
    const video = document.querySelector(e.target.dataset.tsawVideoPlay)
    if (video) {
      e.preventDefault();
      video.play()
    }
  }
  // reset video CC
  onDocAction()
}
const onDocAction = (e) => {
  videoCC = 0
  if (document.documentElement.classList.contains(CLASS_MAKE_WAY_FOR_VIDEO)) {
    document.documentElement.classList.remove(CLASS_VIDEO_PLAYBACK_PAUSED);
  }
  document.documentElement.classList.remove(CLASS_MAKE_WAY_FOR_VIDEO)
}
export const resetVideoInterfaceCounter = () => {
  videoCC = 0
  document.documentElement.classList.remove(CLASS_MAKE_WAY_FOR_VIDEO)
}
export const resetVideoLoopCounter = () => {
  loopCC = 0
}
/**
 * ############################
 * ### Video Event handlers ###
 */
const onTsawVideoLoadedMeta = (e) => {
  // trace("## video loaded meta </")
}
const onTsawVideoLoadedData = (e) => {
  // trace("## video loaded data (...)")
}
const onTsawVideoCanPlay = (e) => {
  // trace("## video can play *")
}
const onTsawVideoCanPlayThrough = (e) => {
  // trace("## video can play through ***")
  // add html class
  document.documentElement.classList.add(CLASS_VIDEO_PLAYBACK_PAUSED)
  // video class list
  const el = e.target
  el.classList.remove(CLASS_VIDEO_LOADING)
  el.classList.add(CLASS_VIDEO_LOADED)
  mediaLoadComplete(el.dataset.id)
}

const onTsawVideoPlaying = (e) => {
  loopCC++
  if (loopCC > 1) {
    document.documentElement.classList.add(CLASS_VIDEO_LOOPED)
  }
  // # remove html class
  document.documentElement.classList.remove(CLASS_VIDEO_PLAYBACK_PAUSED)
  // delay... just in case...
  setTimeout(() => {
    // # remove html class
    document.documentElement.classList.remove(CLASS_VIDEO_PLAYBACK_PAUSED)
  }, 100)
  // video class list
  const el = e.target
  el.classList.add(CLASS_VIDEO_PLAYING)
  // pause main?
  if (!el.muted) {
    pauseSoundMain()
    volumeDownSoundAmbient()
  }
  // start progress bar timer
  videoProgressBarStart(e.target)
  // dispatch reducer
  videoPlaybackStart()
}
const onTsawVideoPause = (e) => {
  // trace("## video pause ||")
  const el = e.target
  el.classList.remove(CLASS_VIDEO_PLAYING)
  // un-pause main?
  if (!el.muted) {
    volumeUpSoundAmbient()
    resumeSoundMain()
  }
  // STOP progress bar timer
  videoProgressBarStop(e.target)
  // dispatch reducer video STOP
  videoPlaybackStop()
}
const onTsawVideoEnded = (e) => {
  // trace("## video ended -|")
  const el = e.target
  // check redirect
  if (el.dataset.tsawNext) {
    // trace("redirect on video eneded", el.dataset.tsawNext)
    // redirect...
    RytmWebflow.aswap.openURL(el.dataset.tsawNext)
  } else {
    el.classList.remove(CLASS_VIDEO_PLAYING)
  }
  // html class
  document.documentElement.classList.remove(CLASS_VIDEO_PLAYBACK_PAUSED)
  // un-pause main?
  if (!el.muted) {
    resumeSoundMain()
  }
  // STOP progress bar timer
  videoProgressBarStop(e.target)
  // dispatch reducer video STOP
  videoPlaybackStop()
}

const onVideoInterval = () => {
  const state = store.getState()
  // if (state.reducerVideo.video_playing) {
    videoCC++
    if (videoCC >= SECONDS_TO_HIDE_INTERFACE) {
      document.documentElement.classList.add(CLASS_MAKE_WAY_FOR_VIDEO)
    } else {
      document.documentElement.classList.remove(CLASS_MAKE_WAY_FOR_VIDEO)
    }
  // } else {
  //   videoCC = 0
  // }
}
// Video PROGRESS BAR
const videoProgressBarStart = (video) => {
  // trace(video)
  clearInterval(videoProgressBarInterval)
  videoProgressBarInterval = setInterval(() => {
    onVideoProgressTimer(video)
  }, 100)
  
}
const videoProgressBarStop = (video) => {
  // trace(video)
  clearInterval(videoProgressBarInterval)
}
const onVideoProgressTimer = (video) => {
  // get progress bar
  const bar = video.dataset.progressBar ? document.querySelector(video.dataset.progressBar) : null
  if (bar) {
    const progress = (video.currentTime / video.duration) * 100
    bar.style.width = progress + "%";
    bar.setAttribute("aria-valuenow", progress + "%")
    if (video.currentTime > 0) {
      // # remove html class
      document.documentElement.classList.remove(CLASS_VIDEO_PLAYBACK_PAUSED)
    }
  }
}

/**
 * ########################
 * # State event handlers #
 */
 const onStoreChange = () => {
  const state = store.getState()
  // check view change
  if (state.reducerRouter.view !== currentView) {
    currentView = state.reducerRouter.view
    // check video
    updateVideosState()
  }
  // check video pause
  if (state.reducerVideo.video_paused !== videoPaused) {
    videoPaused = state.reducerVideo.video_paused
    if (videoPaused) {
      pauseVideos()
    } else {
      resumeVideos()
    }
  }

 }
 